import createCache from '@emotion/cache';

export default function createEmotionCache() {
  // Get nonce from meta tag injected by server
  const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content');
  
  return createCache({
    key: 'css',
    nonce: nonce || undefined,
    prepend: true,
  });
}

